import { getContractSigningTask } from '@/services/implementationmanagement.api';
import { formatDateToWrittenDate } from '@/helpers/dates';
import { useClientStore } from '@/stores/client.js'

export async function buildContractSigning(taskId) {


    const client = useClientStore();

    if(client.clientType == 'IntermediaryClient') return null;


    // Call identity verification API to get the status of the identity verification process
    var response = await getContractSigningTask(taskId);

    if(response.status !== 200 || response.data === null || response.data === undefined) {
        console.error('Error fetching identity verification task');
        return null;
    }

    const task = response.data;

    const card = {
    id: task.taskId,
    title: task.taskName,
    subtitle: 'Sign your SLA with us',
    progress: 0,
    subProgressMessage: '',
    status: task.taskStatus,
    route: '/tasks/contract-signing/' + task.taskId, 
    createdDate: new Date(task.createdDate)
  }
    
  return card 
}

